import React, { useState, useEffect } from 'react';
import api from '../utils/api';

function fmt(n) {
  if (n === undefined || n === null) return '0';
  return Number(n).toLocaleString();
}
function fmtMoney(n) {
  if (n === undefined || n === null) return '$0.00';
  return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function Dashboard({ setTitle }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTitle('Dashboard');
    api.get('/dashboard').then(res => {
      setData(res.data || res);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [setTitle]);

  if (loading) return <div className="loading">Loading dashboard...</div>;
  if (!data) return <div className="empty">Could not load dashboard data.</div>;

  const stats = [
    { label: 'Products', value: fmt(data.products), icon: '📦' },
    { label: 'Customers', value: fmt(data.customers), icon: '👥' },
    { label: 'Suppliers', value: fmt(data.suppliers), icon: '🏭' },
    { label: 'Employees', value: fmt(data.employees), icon: '👤' },
    { label: 'Total Orders', value: fmt(data.orders), icon: '🛒' },
    { label: 'Pending Orders', value: fmt(data.pending_orders), icon: '⏳' },
    { label: 'Revenue', value: fmtMoney(data.revenue), icon: '💰' },
    { label: 'Paid Amount', value: fmtMoney(data.paid_amount), icon: '✅' },
  ];

  const recentOrders = data.recent_orders || [];
  const lowStock = data.low_stock || [];

  function statusClass(s) {
    return 'badge badge-' + (s || 'draft').toLowerCase().replace(/\s+/g, '-');
  }

  return (
    <div className="page">
      <div className="page-header">
        <h1>Dashboard</h1>
        <span className="text-muted" style={{ fontSize: 13 }}>Overview of your business</span>
      </div>

      <div className="stats-grid">
        {stats.map(s => (
          <div className="stat-card" key={s.label}>
            <div className="label">{s.label}</div>
            <div className="value">{s.value}</div>
          </div>
        ))}
      </div>

      <div className="two-col">
        <div className="card">
          <div className="card-header">
            <h3>Recent Orders</h3>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Customer</th>
                  <th>Status</th>
                  <th className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {recentOrders.length === 0 ? (
                  <tr><td colSpan={4} className="empty">No recent orders</td></tr>
                ) : recentOrders.map((o, i) => (
                  <tr key={o.id || i}>
                    <td className="font-mono">{o.order_number}</td>
                    <td>{o.customer_name}</td>
                    <td><span className={statusClass(o.status)}>{o.status}</span></td>
                    <td className="text-right">{fmtMoney(o.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3>Low Stock Alert</h3>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>SKU</th>
                  <th className="text-right">Stock</th>
                </tr>
              </thead>
              <tbody>
                {lowStock.length === 0 ? (
                  <tr><td colSpan={3} className="empty">No low stock items</td></tr>
                ) : lowStock.map((p, i) => (
                  <tr key={p.id || i}>
                    <td>{p.name}</td>
                    <td className="font-mono text-muted">{p.sku}</td>
                    <td className="text-right">
                      <span className="stock-badge stock-low">{p.stock}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
